export default {
	state: { compensation: {}, compensationFile: null, month: null, year: null },
	getters: {
		getCompensation(state) {
			return state;
		},
		// getCompensationFile(state) {
		// 	return state.compensationFile;
		// },
	},
	mutations: {
		setCompensation(state, payload) {
			state.compensation = payload.compensation;
			state.compensationFile = payload.compensationFile;
			state.month = payload.month;
			state.year = payload.year;
		},
		setUpdateCompensation(state, payload) {
			state.compensation = payload.compensation;
			state.compensationFile = payload.compensationFile;
			state.month = null;
			state.year = null;
		},
		clearCompensation(state) {
			state.compensation = {};
			state.compensationFile = null;
			state.month = null;
			state.year = null;
		},
	},
};
